import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useModal from '@hooks/ui/useModal';
import { useFlow } from '@stackflow/react';

import img from './img.png';
import ExternalShopModal from '../../ExternalShopModal';

function MyMenu() {
    const { openModal } = useModal();
    const { push } = useFlow();
    const handlerClick = () => {
        push('ExternalShopModal', { href: '/purchase' });
    };
    return (
        <Container spacing={16}
            onClick={handlerClick} >
            <Image src={img} alt='상품'
                width={64}
                height={64} />
            <Column align='flex-start' fullWidth spacing={5}>
                <Text>
                    겨울에도
                    당연히 얼죽아지
                </Text>
                <OptionText color={colors.gray6} >
                    일회용컵 사용 ㅣ ICE
                </OptionText>
                <Row>
                    <Text size='lg' fontWeight='bold'>1,600</Text>
                    <Text>원</Text>
                </Row>
            </Column>
        </Container>
    );
}

const Container = styled(Row)`
    background-color: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.10);
    min-width: 204px;
    padding: 12px;
`;

const OptionText = styled(Text)`
    font-size: 10px;
`;

export default MyMenu;
